import {IFile} from '../../components/UploadRefundFiles/types';

enum FormStepEnum {
	BENEFICIARY_DATA,
	SEARCH_PROTOCOL,
	SENDING_FILES,
	CONFERENCE,
}

type SendAdditionalDocsData = {
	protocol: string;
	protocolCode: string;
	requestCode: string;
	requestDate: string;
	request: string;
	observations: string;
	files: IFile[];
	refundNumber: string;
};

export {FormStepEnum};
export type {SendAdditionalDocsData};
